import { datadogRum } from '@datadog/browser-rum';
import { getEnvironment, isLocal } from './util/environment';
import { scrubIds } from './util/datadogScrub';

function initDatadogRum() {
  // Deliberately NOT gated on hostname (FD-4134). An earlier `isDevelopment()`
  // check made dev.foresightdata.com permanently un-instrumentable: the keys
  // could be present and RUM would still never start. Enablement is now purely
  // "are the Datadog keys in this env's secret?", the same rule for every env.
  // `isLocal()` stays so a local `npm run dev` does not emit.
  if (
    isLocal() ||
    !import.meta.env.VITE_DATADOG_APPLICATION_ID ||
    !import.meta.env.VITE_DATADOG_CLIENT_TOKEN
  ) {
    return;
  }

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com',
    service: 'portfolio-reporting-ui',
    env: getEnvironment(),
    version: import.meta.env.VITE_DEPLOY_VERSION,
    // Strict privacy: no Session Replay, mask everything by default.
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'mask',
    trackUserInteractions: true,
    // 100% for the trial; documented cost lever to re-tune after rollout.
    sessionSampleRate: 100,
    beforeSend: (event) => {
      if (event.type === 'view' && event.view?.url) {
        event.view.url = scrubIds(event.view.url) ?? event.view.url;
        // view.name is populated independently of view.url (e.g. once view
        // naming via RouteNameMapping lands); scrub it too so ids can't leak
        // through the view-name dimension. No-op while name is unset.
        if (event.view.name) {
          event.view.name = scrubIds(event.view.name) ?? event.view.name;
        }
      }
      if (event.type === 'action' && event.action?.target?.name) {
        event.action.target.name = scrubIds(event.action.target.name) ?? event.action.target.name;
      }
      return true;
    },
  });
}

initDatadogRum();
